import axios from 'axios'
import listFilters from './api_list_filters'

console.dir(document.domain)

let dataUrl = 'https://www.costasolrent.com/data/'
let testSite = false
let localhost = false

if (document.domain !== 'www.costasolrent.com') {
  // dataUrl = 'https://s3.eu-central-1.amazonaws.com/costasolrent.com/data/'
  testSite = true
}

// let apiUrl = 'https://costa-sol-rent-sandbox.herokuapp.com/api'
let apiUrl = 'https://api-sandbox.costasolrent.com/api/costa-sandbox'
// let apiUrl = 'https://amplify.d39jgywwu2zwh0.amplifyapp.com//api'
if (process.env.NODE_ENV === 'development') {
  apiUrl = '/api/costa-sandbox'
  localhost = true
  // dataUrl = 'https://costa-sandbox-site.s3.eu-central-1.amazonaws.com/data/'
}

export default {
  getCacheFor(module, sortBy = '') {
    // console.log('____getCacheFor', module)
    return new Promise((resolve) => {
      if ((localhost || testSite) && sortBy) {
        resolve(this.getRequestWithSort(module, sortBy))
        return
      } else if (localhost || testSite) {
        resolve(
          this.apiRequest('/' + module, [
            {
              key: 'rowsPerPage',
              value: 1000,
            },
          ])
        )
        return
      }
      fetch(dataUrl + module + '.json')
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok')
          }
          return response.json()
        })
        .then((data) => {
          resolve({
            items: data,
          })
        })
        .catch((error) => {
          console.error('Error:', error)
          // Handle errors here
        })
    })
  },

  shareByEmail(data) {
    return this.apiPostRequest('/share', data)
  },

  getRequestWithSort(module, sortBy) {
    // console.log('___getRequestWithSort', module)
    return this.apiRequest('/' + module, [
      {
        key: 'sortBy',
        value: sortBy,
      },
      {
        key: 'rowsPerPage',
        value: 1000,
      },
    ])
  },

  getTemplateVars() {
    return this.getCacheFor('propertyTranslations')
    // return this.apiRequest('/propertyTranslations', [{
    //   key: 'rowsPerPage',
    //   value: 50000
    // }])
  },

  sendBooking(booking) {
    booking.status = '5bebc64446853c27bcfe3dc7'
    return this.apiPostRequest('/bookings', booking)
  },

  sendContact(contact) {
    return this.apiPostRequest('/siteContacts', contact)
  },

  findObjects(filters) {
    filters = listFilters(filters)
    let apiFilters = Object.keys(filters)
      .filter(
        (filterName) =>
          filters[filterName] !== null && filters[filterName] !== 'null'
      )
      .map((filterName) => {
        let value = filters[filterName]
        return {
          key: filterName,
          value: value,
        }
      })
    return this.getListItems('objects', apiFilters)
  },

  getSiteMenu() {
    return this.getCacheFor('menu', 'sortOrder')
    // return this.apiRequest('/menu', [{
    //   key: 'sortBy',
    //   value: 'sortOrder'
    // }])
  },

  getSiteTranslations() {
    return this.getCacheFor('siteTranslations')
    // return this.apiRequest('/siteTranslations', [{
    //   key: 'rowsPerPage',
    //   value: 1000
    // }])
  },

  getBookingExtras() {
    return this.getCacheFor('bookingExtras')
    // return this.apiRequest('/banners', [])
  },

  getSiteBanners() {
    return this.getCacheFor('banners')
    // return this.apiRequest('/banners', [])
  },

  getWeather() {
    return this.getCacheFor('weatherRecordings')
    // return this.apiRequest('/banners', [])
  },

  getObjectRegions() {
    return this.getCacheFor('objectRegions', 'sortOrder')
    // return this.apiRequest('/banners', [])
  },

  getGalleries() {
    return this.getCacheFor('galleries')
    // return this.apiRequest('/galleries', [])
  },

  saveItem(moduleName, data) {
    return new Promise((resolve) => {
      if (data._id) {
        this.apiPutRequest('/' + moduleName + '/' + data._id, data).then(
          (response) => {
            resolve(response)
          }
        )
      } else {
        this.apiPostRequest('/' + moduleName, data).then((response) => {
          resolve(response)
        })
      }
    })
  },

  login(username, password) {
    return new Promise((resolve) => {
      axios
        .post(
          apiUrl + '/login',
          {
            username: username,
            password: password,
          },
          this.sendHeaders()
        )
        .then((response) => {
          if (response.data) {
            resolve(response.data)
          }
          resolve({})
        })
        .catch((error) => {
          resolve(error.response.data)
        })
    })
  },

  logout() {
    return new Promise((resolve) => {
      axios
        .get(apiUrl + '/logout', this.sendHeaders())
        .then((response) => {
          if (response.data) {
            resolve(response.data)
          }
          resolve({})
        })
        .catch((error) => {
          resolve(error.response.data)
        })
    })
  },

  getOneItem(moduleName, itemId) {
    if (itemId === '0') {
      return new Promise((resolve) => {
        resolve({})
      })
    }
    return this.apiRequest('/' + moduleName + '/' + itemId, [])
  },

  getOneItemWithQuery(moduleName, itemId, queries) {
    if (itemId === '0') {
      return new Promise((resolve) => {
        resolve({})
      })
    }
    return this.apiRequest('/' + moduleName + '/' + itemId, queries)
  },

  getListItems(moduleName, filters) {
    return this.apiRequest('/' + moduleName, filters)
  },

  apiRequest(url, filters) {
    return new Promise((resolve) => {
      axios
        .get(
          apiUrl +
            url +
            '?' +
            filters.map((filter) => filter.key + '=' + filter.value).join('&'),
          this.sendHeaders()
        )
        .then((response) => {
          if (response.data) {
            resolve(response.data)
          }
          resolve({})
        })
        .catch((error) => {
          resolve(error.response.data)
        })
    })
  },

  apiPostRequest(url, postData) {
    return new Promise((resolve) => {
      axios
        .post(apiUrl + url, postData, this.sendHeaders())
        .then((response) => {
          if (response.data) {
            resolve(response.data)
          }
          resolve({})
        })
        .catch((error) => {
          resolve(error.response.data)
        })
    })
  },

  apiPutRequest(url, postData) {
    return new Promise((resolve) => {
      axios
        .put(apiUrl + url, postData, this.sendHeaders())
        .then((response) => {
          if (response.data) {
            resolve(response.data)
          }
          resolve({})
        })
        .catch((error) => {
          resolve(error.response.data)
        })
    })
  },

  sendHeaders() {
    return {
      headers: {},
    }
  },
}
